import { applyNeoAiEdit } from "./neoAiApplyEdit";
import { insertMarkdownWithTypingReveal } from "./neoAiMarkdownInsert";
import { captureEditorMarkdown } from "./neoAiEditorUndo";

export async function applyNeoAiAssistantResult({
  editor,
  result,
  documentMarkdownSent,
  cursorPos,
  signal,
  undoStack,
}) {
  if (!editor) {
    return { ok: false, userMessage: "Editor indisponível." };
  }

  undoStack?.push(captureEditorMarkdown(editor));

  const responseMd =
    typeof result.response === "string" ? result.response.trim() : "";
  const pos =
    typeof cursorPos === "number" && Number.isFinite(cursorPos)
      ? cursorPos
      : editor.state.selection.from;

  if (result.edit && typeof result.edit === "object") {
    const applied = await applyNeoAiEdit(editor, {
      edit: result.edit,
      documentMarkdownSent: documentMarkdownSent ?? "",
      cursorPos: pos,
      signal,
    });
    if (!applied.ok) {
      if (undoStack?.undo) {
        undoStack.undo(editor);
      }
      return {
        ok: false,
        userMessage:
          "A IA respondeu, mas não foi possível aplicar a edição no editor (âncoras ou formato). " +
          "Tente reformular o pedido ou use títulos ## nas cláusulas. Detalhe técnico: " +
          String(applied.reason || "desconhecido"),
      };
    }
    return { ok: true, mode: result.edit.edit_mode };
  }

  await insertMarkdownWithTypingReveal(editor, responseMd, pos, { signal });
  return { ok: true, mode: "plain_insert" };
}

export function neoAiApplySuccessHint(mode) {
  if (mode === "replace_between_anchors") {
    return "Trecho indicado foi substituído no documento.";
  }
  if (mode === "full_document") {
    return "Documento atualizado com a versão retornada pela IA.";
  }
  if (mode === "append") {
    return "Texto acrescentado ao final do documento.";
  }
  if (mode === "insert_at_cursor" || mode === "plain_insert") {
    return "Texto inserido no editor.";
  }
  return "Alteração aplicada.";
}

export function neoAiTemplateApplySuccessHint(mode) {
  if (mode === "replace_between_anchors") {
    return "Trecho indicado foi substituído no modelo.";
  }
  if (mode === "full_document") {
    return "Modelo atualizado com a versão retornada pela IA.";
  }
  if (mode === "append") {
    return "Texto acrescentado ao final do modelo.";
  }
  if (mode === "insert_at_cursor" || mode === "plain_insert") {
    return "Texto inserido no modelo.";
  }
  return "Alteração aplicada.";
}
